export default __webpack_public_path__ + "static/media/siphonunlife.84517ba6.png";